import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6b0c24a875aa0014dc1700_1785401990531_87ca0dcc/techlabs/src/app/about/page.tsx");
